__turbopack_context__.v({
  "agentAvatar": "v4XvdG_agentAvatar",
  "agentDetails": "v4XvdG_agentDetails",
  "agentInfo": "v4XvdG_agentInfo",
  "agentName": "v4XvdG_agentName",
  "agentStatus": "v4XvdG_agentStatus",
  "bounce": "v4XvdG_bounce",
  "container": "v4XvdG_container",
  "footer": "v4XvdG_footer",
  "footerLink": "v4XvdG_footerLink",
  "header": "v4XvdG_header",
  "headerActions": "v4XvdG_headerActions",
  "headerButton": "v4XvdG_headerButton",
  "infoNote": "v4XvdG_infoNote",
  "infoPanel": "v4XvdG_infoPanel",
  "input": "v4XvdG_input",
  "inputForm": "v4XvdG_inputForm",
  "loadingDots": "v4XvdG_loadingDots",
  "message": "v4XvdG_message",
  "messageAvatar": "v4XvdG_messageAvatar",
  "messageContent": "v4XvdG_messageContent",
  "messageMeta": "v4XvdG_messageMeta",
  "messageText": "v4XvdG_messageText",
  "messages": "v4XvdG_messages",
  "online": "v4XvdG_online",
  "pulse": "v4XvdG_pulse",
  "sendButton": "v4XvdG_sendButton",
  "slideIn": "v4XvdG_slideIn",
  "statusDot": "v4XvdG_statusDot",
  "suggestionChip": "v4XvdG_suggestionChip",
  "suggestions": "v4XvdG_suggestions",
  "suggestionsLabel": "v4XvdG_suggestionsLabel",
  "system": "v4XvdG_system",
  "user": "v4XvdG_user",
});
